import create from 'zustand';

const tabStateCreator = <TabKey>(initTab: TabKey) =>
  create<{
    activeTab: TabKey;
    setActiveTab: (key: TabKey) => void;
    reset: () => void;
  }>((set) => ({
    activeTab: initTab,
    setActiveTab: (key) => set({ activeTab: key }),
    reset: () => set({ activeTab: initTab }),
  }));

export default tabStateCreator;
